<template>
  <div>
    <input
      v-if="edit"
      v-focus=""
      v-on="$listeners"
      :value="value"
      @change="$emit('update', $event.target.value)"
      @blur="edit = false"
      @keyup.enter="edit = false"
      :class="inputClass"
      :style="inputStyle"
    />

    <p
      v-else
      v-bind="$attrs"
      @click="edit = true"
      :class="pClass"
      :style="pStyle"
    >
      {{ value }}
    </p>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ["value", "inputClass", "inputStyle", "pClass", "pStyle"],
  model: {
    prop: "value",
    event: "update",
  },
  data() {
    return {
      edit: false,
      editor: null,
    };
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>

<style scoped>
input {
  appearance: none;
  outline: none;
  color: #333333;
  width: 100%;
}

input:hover {
}
</style>
